// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// TODO: WARNING in webpack performance recommendations:
//   You can limit the size of your bundles by using import() or require.ensure to lazy load some parts of your application.
//   For more info visit https://webpack.js.org/guides/code-splitting/

// include jQuery in global and window scope (so you can access it globally)
// in your web browser, when you type $('.div'), it is actually refering to global.$('.div')
import $ from 'jquery';
window.$ = window.jQuery = $;
global.$ = global.jQuery = $;
import 'select2';
// import 'select2/dist/css/select2.css';
import 'select2/dist/js/i18n/es.js';

import I18n from "i18n-js";
window.I18n = I18n;

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

require("bootstrap");
require("bootstrap-select");
require("javascripts/scripts.bundle");
require("javascripts/tooltip");
require("@fortawesome/fontawesome-free/js/all");
// require('@client-side-validations/client-side-validations');
require("packs/general");
require("packs/users");
require("packs/permissions");
require("packs/variables");
require("packs/clog");
require("packs/notifications");
require("packs/dismissals");
require("packs/validate_variables_initializer");
require("packs/submit_file");
require("packs/cocoon");
require("packs/sweet-alert-confirm");



// Components with react
require("components/logbook_index");
require("components/role_permissions");
// require("components/batch");

import moment from 'moment';
// include moment in global and window scope (so you can access it globally)
global.moment = moment;
window.moment = moment;
import './daterangepicker.min'

//require("packs/qr-reader")
require("packs/submit_form")

import "./customer_home";
import "./batteries_home";
import "./catalogs";
import "./warranties_form";
import "./quotes_form";
import "./bills_form";
import "./outgoings_form";
import "./warranties_tracking";
import "./batteries_model";
import "./batteries_batch";
import "./batteries_form";
import "./products_form";
import "./products_sale";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
require.context('../../assets/images', true);
// const imagePath = (name) => images(name, true)

import swal from "sweetalert";


// // Support component names relative to this directory:
// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);

window.addEventListener('turbolinks:load', () => {
    $('.select2').select2({
        // tags: true,
        tokenSeparators: [',', ' '],
        // allowClear: true,
        theme: "classic",
        width: 'resolve'
    });
});


$(document).on('turbolinks:load', function () {
    document.querySelectorAll('.no-enter-submit').forEach(function(field) {
        field.addEventListener('keypress', function(e) {
            if (e.which === 13) {
                const target = e.target;
                // Skip prevention for these elements
                if (target.tagName === 'TEXTAREA' ||
                    target.tagName === 'BUTTON' ||
                    target.tagName === 'A' ||
                    target.type === 'submit' ||
                    target.type === 'reset' ||
                    target.type === 'button') {
                    return;
                }
                // Prevent form submission
                e.preventDefault();
                return false;
            }
        });
    });
    if(document.getElementById('daterange-selector')) {
        $(function() {
            $('#daterange-selector').daterangepicker({
                opens: 'left',
                autoUpdateInput: false, // This prevents the input from being updated automatically
                locale: {
                    cancelLabel: 'Cancelar',
                    applyLabel: 'Aplicar',
                    format: 'YYYY/MM/DD'
                }
            }, function(start, end, label) {
                if (start && end) {
                    $(this.element).val(start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD'));
                }
            });
        });
    }
    if(document.getElementById('daterange-selector2')) {
        $(function() {
            $('#daterange-selector2').daterangepicker({
                opens: 'left',
                autoUpdateInput: false, // This prevents the input from being updated automatically
                locale: {
                    cancelLabel: 'Cancelar',
                    applyLabel: 'Aplicar',
                    format: 'YYYY/MM/DD'
                }
            }, function(start, end, label) {
                if (start && end) {
                    $(this.element).val(start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD'));
                }
            });
        });
    }
})

// Mostrar / ocultar custom collapse
function switchCustomCollapse() {
    let detailsElement = document.querySelector('details.custom-collapse');
    if (detailsElement) {
        detailsElement.open = !detailsElement.open;
    }
}
global.switchCustomCollapse = window.switchCustomCollapse = switchCustomCollapse;